export default __webpack_public_path__ + "static/media/mouse-body.aff35d78.svg";